import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Modal,
    ModalBody,
    ModalHeader,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Button,
    ModalFooter
} from '../../../common/materials';

import { ApplicationState } from '../../../store';
import * as UserCompanyMasterStore from '../../../store/user/UserCompanyMaster';
import { resGetUserCompanyMaster } from '../../../models/user/UserCompanyMaster';
import { CompanySystem } from '../Profile.viewmodel';

const SYSTEM_TYPES = ['UAT', 'PRE-PRD', 'PRD'] as const;

type Props = {
    companySystemMaster?: Map<string, string>;
    isOpen?: boolean;
    onClose?: () => void;
    onConfirm?: () => void;
};

function SelectCompanyModal(props: Props) {
    const { companySystemMaster, isOpen, onClose, onConfirm } = props;

    return (
        <Modal isOpen={isOpen} onClose={onClose} showCloseButton>
            <ModalHeader>บริษัทที่ข้อมูลลายเซ็นมีการเปลี่ยนแปลง</ModalHeader>
            <ModalBody>
                <Table>
                    <Thead>
                        <Tr>
                            <Th>บริษัท</Th>
                            {/* <Th>ระบบ</Th> */}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {companySystemMaster && Array.from(companySystemMaster.entries()).map(([companyName, types]) => (
                            <Tr key={companyName}>
                                <Td>{companyName}</Td>
                                {/* <Td>
                                    <div className="flex gap-4">
                                        {SYSTEM_TYPES.map(type => (
                                            <label key={type} className="flex items-center gap-1.5 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={types.has(type)}
                                                    onChange={() => handleChangeCompanySystems(companyName, type)}
                                                    className="cursor-pointer"
                                                />
                                                <span className="text-sm">{type}</span>
                                            </label>
                                        ))}
                                    </div>
                                </Td> */}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </ModalBody>
            <ModalFooter className="gap-4">
                <Button
                    outline
                    size="sm"
                    className="text-gray-400"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    size="sm"
                    onClick={onConfirm}
                    className="bg-primary-900 text-white"
                >
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default SelectCompanyModal;
